import React from 'react'

const ConsentLegalText = () => (
  <>
    <p>
      In a few moments you’ll be able to download an electronic (Adobe Portable Document
      Format, or PDF) copy of the appraisal report associated with your loan application.
      First, you’ll need an authorization code. But even before that, we want to make sure
      that you understand the following.
    </p>
    <br/>
    <p>
      By completing the steps below, you’re consenting to receive the appraisal report
      obtained for your loan application in electronic (PDF) format instead of a paper
      copy. And you’re acknowledging the following:
    </p>
    <br/>
    <li>
      You will not be charged for this electronic copy of the appraisal report or
      subsequent electronic copies of this appraisal report you download from us.
    </li>
    <br/>
    <li>
      You can instead receive a paper copy of the appraisal report rather than this
      electronic copy by not completing our process and contacting your loan officer or
      loan representative. If you choose a paper copy instead, you will not be charged for
      the initial paper copy of the appraisal report you obtain from your loan officer. If
      you decide to obtain this electronic copy, you can still request an extra paper copy
      of the appraisal report from your lender after you receive this electronic copy. But
      please note that there may be a fee involved in sending a paper copy of the
      appraisal report after you’ve already received an electronic copy.
    </li>
    <br/>
    <li>
      You can withdraw this consent at any time at no cost to you by contacting your loan
      officer or loan representative. Your withdrawal of consent will be effective
      immediately.

      Your withdrawal of consent will terminate your ability to obtain an electronic copy
      of the appraisal report from us.

    </li>
    <br/>
    <li>
      Your consent applies only to the electronic delivery of this appraisal report. Your
      mortgage lender or mortgage representative will provide you with any disclosures or
      other documents that may be associated with your appraisal. Your consent doesn’t
      apply to other files or documents related to your loan application, other subsequent
      valuations that may be obtained by the lender in connection with your loan
      application, or other loan applications or transactions.
    </li>
    <br/>
    <li>
      If you have submitted a joint application, you are the primary borrower and are
      authorized to accept the electronic delivery of the appraisal report on behalf of
      the other borrowers.
    </li>
    <br/>
    <li>
      You can update your contact information, including your email address, by contacting
      your loan officer or loan representative.
    </li>
    <br/>
    <li>
      Your computer or other device meets the hardware and software requirements, as
      described below, to enable delivery, access to, and retention of the appraisal
      report.
    </li>

    <br/>
    <p>
      In order to enable successful and complete electronic delivery, access to, and
      retention of the appraisal report, your computer or device must meet certain
      hardware and software requirements. You’ll need an active email account, an Internet
      connection, any device (e.g., computer desktop, laptop, mobile device) using
      operating systems and internet browsers that support viewing Portable Document
      Format (PDF) with a PDF viewer, such as Adobe Reader©, that can open and read PDF
      files. You can obtain a free copy of Adobe Reader software here:
      https://www.adobe.com/acrobat/pdf-reader.html.
    </p>
    <br/>
    <p>
      If you click “I consent to receive the appraisal report in electronic form” below
      and click “Continue,” this means that you have consented to receive an electronic
      copy of your appraisal report. To confirm your consent, we will then need to make
      sure your computer or device is able to open the electronic (PDF) copy of the
      appraisal report. To do this, we’re going to give you an authorization code to enter
      before you can access the appraisal report. To get your authorization code, here’s
      what you do. Click the button ‘Download Auth Code’. When you do, an electronic file
      in PDF format with your authorization code on it should open or be saved to your
      computer or device. (You may be given a choice to either ‘Open’ or ‘Save’ the file.
      If you are given a choice, choose ‘Open’.) If it downloads without opening, go to
      the folder on your computer or device where the file is saved, and open the file
      from there.
    </p>
    <br/>
    <p>
      If the file opens and you can see your authorization code — great! That means your
      computer or device is able to open the electronic (PDF) copy of the appraisal
      report, too. Enter the authorization code where requested on the same page and click
      ‘”Download Appraisal” to obtain, download and/or print an electronic copy of your
      appraisal report. Of course, if you change your mind about receiving an electronic
      copy of your appraisal report, on this very same page, you may click “Deny” and
      refuse to provide consent to electronic delivery. Just make sure to let your loan
      officer or loan representative know that you’ve withdrawn from the electronic
      process so that they may provide you with a paper copy of the appraisal report.
    </p>
    <br/>
    <p>
      Unless you subsequently withdraw your consent to receiving an electronic copy of
      your appraisal report, you may access and download subsequent electronic copies of
      the appraisal for up to 90 days. There is no guarantee the report will be available
      after 90 days from the date you give your consent.
    </p>
    <br/>
    <p>
      Finally, if you have any trouble getting the authorization code or accessing or
      opening the appraisal report, please contact your loan officer or loan
      representative.
    </p>
  </>
)

export default ConsentLegalText
